const WodaOdczytyUdzialyProcentyTHead = () => {

    return (
        <thead>
            <tr>
                <th rowSpan={2}>Mieszkaniec</th>
                <th rowSpan={2}>Adres</th>
                <th rowSpan={2}>Pow. lok.</th>
                <th colSpan={2}>Odczyty</th>
                <th colSpan={2}>Zużycie</th>
                <th rowSpan={2} >Koszt zimnej wody</th>
                <th rowSpan={2}>Abonament za<br/>okres rozliczeniowy</th>
                <th rowSpan={2}>Koszt podgrzania wody</th>
                <th rowSpan={2}>Zw + Cw + Abo</th>
                <th colSpan={4}>Zaliczka</th>
                <th colSpan={2}>Strata / nadwyzka</th>
                <th rowSpan={2}>Saldo</th>
            </tr>
            <tr className="second">
                <th>w. zimna</th>
                <th>w. ciepła</th>
                <th>w. zimna</th>
                <th>w. ciepła</th>
                <th>w. zimna</th>
                <th>abo</th>
                <th>w. ciepła</th>
                <th>razem</th>
                <th>(zł)</th>
                <th>(m³ %)</th>
            </tr>
        </thead>
    )
}

export default WodaOdczytyUdzialyProcentyTHead;